import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';

import SliderComments from './SliderComments';

import images from '../../../static/images/RealtorLanding';
import * as styles from './TabSellingProperties.scss';


class TabSellingProperties extends Component {
  render() {
  const translate = this.props.translate('NavTabs', 'internationalExposure');
  return (
    <div className={styles.tabWrapper}>
      <div className={styles.sellingPropertiesContainer}>
        <div className={styles.sellingPropertiesContent}>
            <h1>{translate('title')}</h1>
            <p>{translate('blockValue')}</p>
            <p>{translate('buyPropertyHere')}</p>
            <p>{translate('uploadAdToSite')}</p>
            <p>{translate('severalStoriesIntermediaries')}</p>
        </div>
        <div className={styles.flagsImage}>
            <img src={images.flagsImage} alt="realtor" />
        </div>
      </div>
        <SliderComments />
    </div>
  );
  }
}

TabSellingProperties.propTypes = {
  translate: PropTypes.func
};

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'RealtorLanding')
});

export default connect(mapStateToProps)(TabSellingProperties);
